import React from 'react'

const AgentProfile = () => {
  return (
    <div style={{marginTop:"80px"}}>AgentProfile</div>
  )
}

export default AgentProfile